import { spacing } from "@universityofmaryland/web-token-library";
import { objectWithClassName } from "../../utilities/create/jss.js";
import "../../node_modules/.pnpm/postcss@8.5.8/node_modules/postcss/lib/postcss.js";
import "../../node_modules/.pnpm/postcss-js@4.1.0_postcss@8.5.8/node_modules/postcss-js/index.js";
import "../../node_modules/.pnpm/postcss-nesting@13.0.2_postcss@8.5.8/node_modules/postcss-nesting/dist/index.js";
import "../../_virtual/index.js";
const classNamePrefix = "umd-layout-alignment-block";
const center = objectWithClassName({
  display: "flex",
  justifyContent: "center",
  className: [
    `${classNamePrefix}-center`,
    /** @deprecated Use 'umd-layout-alignment-block-center' instead */
    "umd-layout-element-alignment-center"
  ]
});
const stacked = objectWithClassName({
  display: "flex",
  flexDirection: "column",
  "& > *": {
    marginTop: spacing.sm,
    "&:first-child": {
      marginTop: "0"
    }
  },
  className: [
    `${classNamePrefix}-stacked`,
    /** @deprecated Use 'umd-layout-alignment-block-stacked' instead */
    "umd-media-with-caption"
  ]
});
export {
  center,
  stacked
};
//# sourceMappingURL=block.js.map
